export function trackPage(url) {
    if (typeof window.umami !== 'undefined') {
        window.umami.track({ url })
    }
}
